import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { QUOTE_REQUEST_PATH } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

/**
 * 비로그인 안내 — 로그인하면 이 화면(/request)으로 돌아온다.
 * 돌아올 곳은 보호 라우트 가드와 같은 방식(location state 의 from)으로 로그인 화면에 넘긴다.
 */
export const QuoteGuestPrompt = (): ReactElement => (
  <div className="flex flex-col gap-6 bg-muted/70 px-6 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-10 sm:py-12">
    <p className="text-lg leading-snug font-semibold tracking-[-0.02em] text-balance sm:text-xl">
      로그인하면 저장한 디자인으로 바로 견적을 요청할 수 있어요
    </p>
    <div className="flex gap-2 sm:shrink-0">
      <Link
        to="/sign-in"
        state={{ from: QUOTE_REQUEST_PATH }}
        className={cn(buttonVariants({ size: 'lg' }), 'h-12 flex-1 px-8 sm:flex-none')}
      >
        로그인
      </Link>
      <Link
        to="/sign-up"
        className={cn(
          buttonVariants({ variant: 'outline', size: 'lg' }),
          'h-12 flex-1 border-foreground/20 bg-background px-8 sm:flex-none',
        )}
      >
        회원가입
      </Link>
    </div>
  </div>
);
